import React , { useState , useEffect } from 'react'

import { ApiCallGet } from '../ApiCall/ApiCall'



export default function ShowImages( { arrIndex  , usuario , folioSisact}) {

    const [images,setImages] = useState([]) // de inicio el arreglo vacio
    const [isLoaded,setIsLoaded] = useState(false)

    useEffect(() => {
        console.log( "Images.length *******= " + images.length )
    } , [images])

    useEffect(()=> {
        console.log( "ShowImages folioSisact = " , folioSisact  ) // Se llama cada vez que cambia el folio

        if ( !folioSisact ) return ; // Si no tenemos folio aún, no hacemos nada

        if ( isLoaded ) return ;

        console.log( "usuario = " + usuario )

        // Nuevo endpoint que usa folioSisact para obtener idmsgseg y luego las imágenes de evidencias
        ApiCallGet( 'imagesbyfolio/' + folioSisact + "/" + usuario )
            .then( (response) => {
                //console.log ( "Response imagesbyfolio = " , response )

                setImages( response )
                setIsLoaded(true)
            })
            .catch( (error) => {
                console.log( error )
            })

    } , [folioSisact, usuario]) // Se ejecuta cada vez que cambia el folio o el usuario

    // arrIndex ya no se usa; lo dejamos en la firma para no romper otros componentes
  return (
    <div>
        {
            images.map( (image , index ) => {
                return (
                    <>
                    <p>Imagen FolioSisact={folioSisact}</p>
                    {
                        image !== 'null' && (
                            <>
                            <img
                              style={{width:'400px'}}
                              src={ 'data:image/jpeg;base64,' + image }
                              alt='Imagen'
                            />
                            </>
                        ) 
                    }

                    {
                        image === 'null' && (
                            <p>No hay imagen</p>
                        )
                    }
                    


                    {/*<img src={`data:image/jpeg;base64,${Buffer.from(image , 'base64')}`}  alt='Imagen'/>*/}

                    {/* base64ToBlob(base64String, 'image/jpeg'); */}
                    {/*<img src=`data:image/jpeg;base64,${image}` alt="Imagen" />*/} 
                    
                    </>
                )
            })
        }
    </div>
  )
}
